import { AutocompleteField } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { currencyOptions } from "shared-utils";

import { MESSAGES } from "./message-definitions";

export const ReportingCurrencySelect = ({
  initialValue,
  error,
  disabled,
  onChange,
}: {
  initialValue?: string;
  error?: string;
  disabled?: boolean;
  onChange: (item: { id: string; text: string }) => void;
}) => {
  const intl = useIntl();

  return (
    <AutocompleteField
      name="accountingCurrency"
      label={intl.formatMessage(MESSAGES.reportingCurrencyFieldLabel)}
      helperText={intl.formatMessage(MESSAGES.reportingCurrencyHelperText)}
      disabled={disabled}
      error={error}
      options={currencyOptions}
      initialValue={initialValue}
      onChange={(id) => {
        const currency = currencyOptions.find((currency) => currency.id === id);
        if (currency) {
          onChange(currency);
        }
      }}
    />
  );
};
